import PortalClienteService from "services/bases/PortalClienteService";

class AutorizacoesService extends PortalClienteService{
    async EnviarCodigoAutorizacaoCotacao(cotacaoId){
        return await this.post(`autorizacoes/EnviarCodigoAutorizacaoCotacao`,{"cotacaoId": cotacaoId})
    }
    async ValidarCodigoAutorizacaoCotacao(cotacaoId, codigo){
        return await this.post(`autorizacoes/ValidarCodigoAutorizacaoCotacao`,{"cotacaoId": cotacaoId, "codigo":codigo})
    }
}

export default new AutorizacoesService();